import React from 'react';

import posRightBg from '~/images/free-trial-bg.svg';
import PartialCTA from '../partials/cta';

interface FreeTrialCenterProps {
  block: {
    title: string;
    text: string;
    text_position_class: string;
    cta_field: {
      cta_link: string;
      cta_text: string;
    };
  };
}

export default function FreeTrialCenter({ block }: FreeTrialCenterProps) {
  return (
    <>
      {block.text_position_class === 'pos-right' ? (
        <img
          src={posRightBg}
          alt={block.title}
          title={block.title}
          loading='lazy'
        />
      ) : (
        ''
      )}
      <div className='freetrial-wr'>
        <div className='content-wr'>
          {block.title && (
            <h2 dangerouslySetInnerHTML={{ __html: block.title }}></h2>
          )}
          {block.text && (
            <p dangerouslySetInnerHTML={{ __html: block.text }}></p>
          )}
        </div>
        <div className='cta-wr'>
          {block.cta_field && <PartialCTA data={block.cta_field} />}
        </div>
      </div>
    </>
  );
}
